import { render, staticRenderFns } from "./ChartSessions.vue?vue&type=template&id=487eb3c2"
import script from "./ChartSessions.vue?vue&type=script&lang=js"
export * from "./ChartSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports